import {ComponentType, createContext, useContext} from 'react';
import {
  Conversation,
  ConversationMessage,
  AttachmentConversationMessage,
  ButtonOptionsConversationMessage,
  ArticlesConversationMessage,
  ButtonsConversationMessage,
  SelectOptionsConversationMessage,
  TextConversationMessage,
  TextWithAttachmentsConversationMessage,
  InlineDataConversationMessage,
  RichTextConversationMessage,
  CustomPartConversationMessage,
  AgentCall,
} from '@stripe-internal/conversations-client';

export interface MessageComponentProps {
  conversation: Conversation;
  message: ConversationMessage;
  animated?: boolean;
  disableInteraction?: boolean;
  avatar?: React.ReactNode;
}

export interface MessageComponentRegistry {
  'attachment-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: AttachmentConversationMessage;
    }
  >;
  'select-options-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: SelectOptionsConversationMessage;
    }
  >;
  'button-options-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: ButtonOptionsConversationMessage;
    }
  >;
  'articles-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: ArticlesConversationMessage;
    }
  >;
  'buttons-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: ButtonsConversationMessage;
    }
  >;
  'text-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: TextConversationMessage;
    }
  >;
  'text-with-attachments-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: TextWithAttachmentsConversationMessage;
    }
  >;
  'inline-data-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: InlineDataConversationMessage;
    }
  >;
  'rich-text-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: RichTextConversationMessage;
    }
  >;
  'custom-part-conversation-message'?: ComponentType<
    MessageComponentProps & {
      message: CustomPartConversationMessage;
    }
  >;
  'tool-call'?: ComponentType<{
    conversation?: Conversation;
    agentCall: AgentCall;
    messageId: string;
  }>;
  'structured-content'?: ComponentType<{
    structuredContent: string;
    onComplete: () => void;
    isDone?: boolean;
    messageId: string;
  }>;
}

export const MessageComponentContext = createContext<MessageComponentRegistry>(
  {},
);

export function useMessageComponents() {
  return useContext(MessageComponentContext);
}
